module.exports = __webpack_public_path__ + "static/media/pick_place_bot.f0556287.jpg";